import { EngineSDK } from '@dilvant/engine-sdk';
import { SDK } from '@dilvant/bizcard-sdk';

import AOS from 'aos';
AOS.init();

SDK.setEnv("prod");
EngineSDK.setEnv("prod");
